import React from "react";
import { Snackbar, Alert } from "@mui/material";
export default function SnackbarAlert({ open, setOpen, message, severity = "success" }) {
    return (
        <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={() => setOpen(false)}              
            anchorOrigin={{ vertical: "top", horizontal: "right" }}>
            <Alert severity={severity} variant="filled" onClose={() => setOpen(false)}>{message}</Alert>
        </Snackbar>
    );
}